"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const style_1 = require("./style");
function Toast({ isOpen, onClose, severity, closeText, message, anchorOrigin, }) {
    const handleClose = (event) => {
        onClose(event);
    };
    return isOpen ? (react_1.default.createElement(Snackbar_1.default, { open: isOpen, onClose: onClose, anchorOrigin: anchorOrigin },
        react_1.default.createElement(style_1.CustomAlert, { onClose: handleClose, severity: severity, variant: "filled", closeText: closeText }, message))) : null;
}
exports.default = Toast;
